module.exports = __webpack_public_path__ + "static/media/fiftyassists.c703de9c.jpg";